<template>
  <div class="header" style="background-color: white; justify-content: space-between;">
    <a :href="loinfo.header_link">
      <img :src="loinfo.main_logo" style="padding-left: 5px" />
    </a>
    <div style="display: flex; flex-direction: row; height: 100%; justify-content: center; align-items: center;">
      <div class="two-pane-vertical lo-contact">
        <div class="" style="padding: 5px;">
          <strong>{{ loinfo.first_name }} {{ loinfo.last_name }}</strong>
        </div>
        <div>
          {{ loinfo.phone_number }}
        </div>
      </div>
      <img class="header-img" :src="loinfo.app_header_image ? loinfo.app_header_image : loinfo.lo_image" />
    </div>
  </div>

  <div v-if="!appSavable"
    id="widget"
    class="em-widget"
    data-width="100%"
    data-height="800px"
    data-min-height="800px"
    data-site-id="1297790669"
    data-name="ecc-loan-app"
    :data-config="appworkflow"
    data-aria-label="My Loan Application"
  ></div>

  <div class="create-acct-notice" v-if="appSavable">
    <div class="loan-launch-description-container">
      <img class="loan-launch-logo" :src="loanLaunchLogoSource" />

      <p class="notice-header">
        {{ noticeHeader }}
      </p>

      <p class="loan-launch-description">
        {{ noticeDescription }}
      </p>

      <div class="create-acct-btns-container">
        <k-button class="create-acct-btn" @click="goToSavableApp">
          {{ primaryCtaText }}
        </k-button>

        <p class="sign-in-container" v-if="!hasApplicationId">
          Already have an account?
          <span class="sign-in-btn" @click="goToSavableApp" role="button">Log In</span>
        </p>
      </div>
    </div>
  </div>

  <LOFooter :loinfo="loinfo"></LOFooter>
</template>

<script>
import { Button } from '@progress/kendo-vue-buttons';
import apiService from "../api/api.service.js";
import LOFooter from "../components/LOFooter.vue";

export default {
  data: function () {
    return {
      contactFormDialog: false,
      loinfo: {},
      larFromQuery: "",
      loanLaunchLogoSource: '/Loan Launch Logo.png',
      appworkflow: '',
      appSavable: true,
      showWidget: false,
      workflowId: null,
      applicationId: null
    };
  },
  name: "ApplyView",
  props: {
    msg: String,
  },
  components: {
    LOFooter,
    'k-button': Button
  },
  computed: {
    hasApplicationId() {
      return this.applicationId !== null && String(this.applicationId).trim() !== '';
    },
    noticeHeader() {
      if (this.hasApplicationId) return 'Log in to Loan Launch to continue your application';
      return 'Create a LoanLaunch account or log in to start your application';
    },
    noticeDescription() {
      if (this.hasApplicationId) {
        return 'Good news. We already created your Loan Launch account. Tap Log In and we will verify you using your phone number and a one time pass code so you can pick up right where you left off.';
      }
      return 'LoanLaunch is your private and secure portal to monitor the status of your mortgage, securely send us documents, and chat with your loan team.';
    },
    primaryCtaText() {
      return this.hasApplicationId ? 'Log In' : 'Create Account';
    }
  },
  methods: {
    async getLOInfo() {
      return apiService
        .GetLOPage(this.larFromQuery)
        .then((res) => {
          this.loinfo = res.data.data[0];
          document.title = "Mortgage Application";

          this.updateMetaTags({
            "og:title": `${this.loinfo.first_name} ${this.loinfo.last_name} - Mortgage Application`,
            "og:description": `Apply now with ${this.loinfo.first_name} ${this.loinfo.last_name} for personalized mortgage services.`,
            "og:image": this.loinfo.app_header_image || this.loinfo.lo_image,
            "og:url": window.location.href,
            "og:type": "website",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
 goToSavableApp() {
  const url = new URL('https://apply.loanlaunch.com/');
  const q = this.$route?.query || {};

  Object.entries(q).forEach(([k, v]) => {
    if (v === null || v === undefined) return;
    if (Array.isArray(v)) v.forEach(x => url.searchParams.append(k, String(x)));
    else url.searchParams.set(k, String(v));
  });

  if (!url.searchParams.get('lar') && this.larFromQuery) url.searchParams.set('lar', this.larFromQuery);
  if (!url.searchParams.get('workflowid') && this.workflowId) url.searchParams.set('workflowid', String(this.workflowId));
  if (this.hasApplicationId && this.applicationId) url.searchParams.set('id', String(this.applicationId));

  window.location.assign(url.toString());
},
    updateMetaTags(metaData) {
      const existingMetaTags = document.querySelectorAll('meta[data-dynamic="true"]');
      existingMetaTags.forEach((tag) => tag.remove());

      Object.entries(metaData).forEach(([key, content]) => {
        const meta = document.createElement("meta");

        if (key.startsWith("og:")) meta.setAttribute("property", key);
        else meta.setAttribute("name", key);

        meta.setAttribute("content", content);
        meta.setAttribute("data-dynamic", "true");
        document.head.appendChild(meta);
      });
    }
  },
  async mounted() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    this.larFromQuery = params.lar;
    this.workflowId = params.workflowid;
    this.applicationId = params.id;

    if (this.workflowId === '207437') {
      this.appSavable = false;
      this.appworkflow = '{"workFlowId":"' + this.workflowId + '","externalLoginWindow":"true","lar":"' + this.larFromQuery + '"}';
    } else {
      this.appSavable = true;
    }

    await this.getLOInfo();
    this.$store.commit('updateLOInfo', this.loinfo);

    if (!this.appSavable) {
      this.showWidget = true;
    }
  }
};
</script>

<style scoped>
@import "/src/assets/css/homeView.css";
.em-widget {
  margin-top: 60px;
}

.header-img-container{
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.header-img {
  width: 90px;
  height: 90px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 20px;
}

.lo-contact{
  margin: 20px 10px;
  font-size: 1rem;
}

.create-acct-notice {
  min-height: 450px;
  padding: 0 15px;
  margin-top: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.create-acct-notice .notice-header {
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 1.1rem;
}

.create-acct-notice .loan-launch-description-container {
  max-width: 550px;
  padding: 20px 15px;
  margin: 15px 0;
  font-size: 1rem;
  background-color: #f0f6fe;
  line-height: 1.4;
  border: 1px solid #b9d6f9;
  border-radius: 8px;
}

.create-acct-notice .loan-launch-description-container .loan-launch-description {
  margin-bottom: 35px;
}

.create-acct-btn {
  background-color: #b3d4ff;
  font-weight: 600;
  padding: 8px;
  color: black;
  font-size: .9rem;
  margin: 0 10px;
  min-width: 160px;
}

.loan-launch-logo {
  width: 250px;
}

.sign-in-container {
  margin-top: 10px;
  margin-bottom: 5px;
}

.sign-in-btn {
  color: #0000FF;
  cursor: pointer;
  font-weight: 600;
  margin-left: 3px;
}

@media (max-width: 782px){
  .lo-contact {
    font-size: .7rem;
  }
}

@media (max-width: 735px){
  .header{
    padding: 0px;
  }
  .header-img{
    display: none;
  }
}

@media (max-width: 524px){
  .em-widget{
    margin-top: 90px;
  }

  .create-acct-notice .notice-header {
    font-size: .9rem;
  }

  .loan-launch-logo {
    width: 225px;
  }

  .create-acct-notice .loan-launch-description-container {
    font-size: .9rem;
    padding: 15px;
  }
}

@media (max-width: 500px){
  .lo-contact{
    width: 90px;
  }
  .em-widget{
    margin-top: 110px;
  }
}

@media (max-width: 450px){
  body{
    margin-top: 125px !important;
  }
}
</style>